import { useTranslation } from 'react-i18next'
import { Grid } from '@material-ui/core'
import { Field } from 'formik'
import { FieldLabel } from 'shared/components'
import { PaymentMethod, SummaryFormFields } from '../../types'
import PaymentMethodField from '../PaymentMethodField'
import {
  TextField,
  Title,
  Form,
  PaymentMethodsWrapper,
  PaymentMethodWrapper,
} from './PaymentSummaryForm.style'

interface PaymentSummaryFormProps {
  paymentMethods: PaymentMethod[]
}

const PaymentSummaryForm = ({ paymentMethods }: PaymentSummaryFormProps) => {
  const { t } = useTranslation()

  return (
    <Form>
      <Grid container>
        <Grid container item xs={12}>
          <Grid container item xs={12}>
            <Title>{t('paymentSummary.paymentMethod')}</Title>
          </Grid>
          <PaymentMethodsWrapper container>
            {paymentMethods.map(({ id, name: label, imageUrl }) => (
              <PaymentMethodWrapper key={`payment-method-${id}`}>
                <Field
                  component={PaymentMethodField}
                  name={SummaryFormFields.PaymentMethod}
                  value={id}
                  label={label}
                  imageUrl={imageUrl}
                />
              </PaymentMethodWrapper>
            ))}
          </PaymentMethodsWrapper>
        </Grid>
        <Grid container item xs={10}>
          <Grid container item xs={12}>
            <Title>{t('paymentSummary.title')}</Title>
          </Grid>
          <Grid container spacing={10}>
            <Grid
              container
              item
              xs={6}
              direction="column"
              alignItems="stretch"
              spacing={3}
            >
              <Grid item>
                <TextField
                  name={SummaryFormFields.TaxNumber}
                  label={<FieldLabel>{t('company.taxNumber')}</FieldLabel>}
                />
              </Grid>
              <Grid item>
                <TextField
                  name={SummaryFormFields.CompanyName}
                  label={
                    <FieldLabel>{t('contractor.fullCompanyName')}</FieldLabel>
                  }
                />
              </Grid>
            </Grid>
            <Grid
              container
              item
              xs={6}
              direction="column"
              alignItems="stretch"
              spacing={3}
            >
              <Grid item>
                <TextField
                  name={SummaryFormFields.Street}
                  label={<FieldLabel>{t('contractor.street')}</FieldLabel>}
                />
              </Grid>
              <Grid item container spacing={2}>
                <Grid item xs={6}>
                  <TextField
                    name={SummaryFormFields.BuildingNumber}
                    label={
                      <FieldLabel>{t('contractor.buildingNumber')}</FieldLabel>
                    }
                    wrapError
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    name={SummaryFormFields.ApartmentNumber}
                    label={
                      <FieldLabel required={false}>
                        {t('contractor.apartmentNumber')}
                      </FieldLabel>
                    }
                  />
                </Grid>
              </Grid>
              <Grid item container spacing={2}>
                <Grid item xs={4}>
                  <TextField
                    name={SummaryFormFields.ZipCode}
                    label={<FieldLabel>{t('contractor.zipCode')}</FieldLabel>}
                    wrapError
                  />
                </Grid>
                <Grid item xs={8}>
                  <TextField
                    name={SummaryFormFields.City}
                    label={<FieldLabel>{t('contractor.city')}</FieldLabel>}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Form>
  )
}

export default PaymentSummaryForm
